//* 장례식장 추가정보 — 부고 "오시는 길" 주차안내 뒤에 배열 순서대로 노출
import { FC, useMemo } from 'react';

import { FuneralHomeAdditionalInfo } from '@shared/api/funeralHomeInfo/funeralHomeInfo.interface';
import { Image as ImageType } from '@shared/api/media/media.interface';
import { BucketImage } from '@shared/components/BucketImage';

interface Props {
  //* 없거나 빈 배열이면 아무것도 그리지 않는다 (추가정보 미반영 서버에서도 안전)
  additionalInfos?: FuneralHomeAdditionalInfo<ImageType | string>[];
}

//* 사진 없음으로 취급하는 두 경우를 한 번에 — 문자열 id(populate 없는 서버) · null(원본 삭제)
const imageUrlOf = (image?: ImageType | string | null) =>
  !image || typeof image === 'string' ? undefined : image.url;

export const ObituaryFuneralHomeAdditionalInfos: FC<Props> =
  function ObituaryFuneralHomeAdditionalInfos({ additionalInfos }: Props) {
    const renderItems = useMemo(() => {
      return (
        (additionalInfos ?? [])
          .map((item, index) => ({
            key: item._id ?? `additionalInfo-${index}`,
            name: item.name?.trim() ?? '',
            description: item.description?.trim() ? item.description : undefined,
            imageUrl: imageUrlOf(item.image),
          }))
          //* 제목만 있고 내용이 없는 항목은 건너뛴다
          .filter((item) => item.name && (item.description || item.imageUrl))
      );
    }, [additionalInfos]);

    if (renderItems.length === 0) return null;

    return (
      <>
        {renderItems.map((item) => (
          <div key={item.key} className="space-y-2 px-6">
            <p className="text-16 font-bold leading-6 text-gray-500">{item.name}</p>
            {item.description && (
              <p className="whitespace-pre-line break-keep text-sm">{item.description}</p>
            )}
            {item.imageUrl && (
              <BucketImage value={item.imageUrl} alt={item.name} className="w-full" />
            )}
          </div>
        ))}
      </>
    );
  };
